module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-list-item', {
    staticClass: "selectUser",
    class: {
      'on': _vm.selectPerson == _vm.keys
    },
    attrs: {
      "disabled": _vm.noclick
    },
    on: {
      "click": function($event) {
        _vm.chooseThis(_vm.keys)
      }
    }
  }, [_c('mu-avatar', {
    class: _vm.colorSelect,
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "slot": "leftAvatar"
    },
    slot: "leftAvatar"
  }, [_vm._v(_vm._s(_vm.showName))]), _vm._v(" "), _c('span', {
    staticClass: "personal-wrap"
  }, [(_vm.flag != 1) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm._f("short")(_vm.info.name)))]), _c('span', {
    staticClass: "personal-sex"
  }, [_vm._v("，" + _vm._s(_vm.sex) + "，" + _vm._s(_vm.info.age) + "岁")]), _vm._v(" "), (_vm.flag == 2) ? _c('span', [_vm._v("，" + _vm._s(_vm.info.mobile))]) : _vm._e()]) : _c('span', [(_vm.info.user_name) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm._f("short")(_vm.info.user_name)) + "，")]), _vm._v(_vm._s(_vm.info.user_mobile))]) : _c('span', [_c('b', [_vm._v(_vm._s(_vm._f("short")(_vm.info.name)) + "，")]), _vm._v(_vm._s(_vm.info.mobile))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-284e8cdb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/personal.vue
// module id = 966
// module chunks = 2